import * as applyActions from './applyTemplate/actions';
import * as defaultActions from './defaultTemplate/actions';
import { API_URL, getIdentifierFrom201, templateResource } from './templateResource';
const createOneWithSharingId = (body, createOneOptions) => async dispatch => {
  // careful with concurent POST
  const label = `${templateResource.name}_create`;
  const resp = await dispatch(
  // $FlowFixMe[cannot-spread-indexer]
  templateResource.createOne(API_URL, body, {
    label,
    ...createOneOptions
  }));

  // $FlowFixMe[incompatible-call] - don't know how to declare correct response
  // $FlowFixMe[incompatible-indexer]
  // $FlowFixMe[incompatible-exact]
  // $FlowFixMe[incompatible-variance]
  // $FlowFixMe[prop-missing]
  const uuid = getIdentifierFrom201(resp);
  const labelFetchOne = `${templateResource.name}_${uuid}`;
  const uri = `${API_URL}/${uuid}`;
  return dispatch(templateResource.fetchOne(uri, {
    label: labelFetchOne
  }));
};
export default {
  ...applyActions,
  ...defaultActions,
  createOneWithSharingId
};